import { AxiosRequestConfig } from "axios";
import { GranularCatalogConfig } from "@granular/fabric-catalog-helpers";
import merge from "lodash/merge";

import { AuthSvcInstance } from "./schemas";
import tokens from "./tokens";

const createAuthSvcInstance = (
  authRequestConfig: GranularCatalogConfig,
  instanceRequestConfig?: AxiosRequestConfig,
): AuthSvcInstance => {
  return {
    refreshTokens: ({ token, axiosRequestConfig, domain }) =>
      tokens.refreshTokens({
        token,
        authRequestConfig,
        axiosRequestConfig: merge(instanceRequestConfig, axiosRequestConfig),
        domain,
      }),
    fetchTokens: ({ code, axiosRequestConfig, domain }) =>
      tokens.fetchTokens({
        code,
        authRequestConfig,
        axiosRequestConfig: merge(instanceRequestConfig, axiosRequestConfig),
        domain,
      }),
  };
};

export default createAuthSvcInstance;
